module.exports = __webpack_public_path__ + "media/recipes/112-85983806.png";